module.exports = __webpack_public_path__ + "static/media/AorB.4da7970c.svg";